export default __webpack_public_path__ + "static/Cervejas-bud-063dc45963b6cdae927828ee3dde165d.jpg";